import { useState, useEffect, useRef, useCallback } from "react"
import { setTyping, clearTyping, watchTyping } from "firebase/groupsService"

export function useTyping(
	groupId: string | null,
	loggedUserId: string,
	myName: string
) {
	const [typingNames, setTypingNames] = useState<string[]>([])
	const unsubRef = useRef<(() => void) | null>(null)

	useEffect(() => {
		if (unsubRef.current) unsubRef.current()
		if (!groupId) {
			setTypingNames([])
			return
		}
		const unsub = watchTyping(groupId, loggedUserId, setTypingNames)
		unsubRef.current = unsub
		return () => {
			unsub()
			if (groupId && loggedUserId)
				clearTyping(groupId, loggedUserId).catch(() => {})
		}
	}, [groupId, loggedUserId])

	const startTyping = useCallback(() => {
		if (groupId && loggedUserId)
			setTyping(groupId, loggedUserId, myName).catch(() => {})
	}, [groupId, loggedUserId, myName])

	const stopTyping = useCallback(() => {
		if (groupId && loggedUserId)
			clearTyping(groupId, loggedUserId).catch(() => {})
	}, [groupId, loggedUserId])

	return { typingNames, startTyping, stopTyping }
}
